export default "__VITE_ASSET__68751491__"